function cancelEvent(e: React.MouseEvent) {
    e.stopPropagation();
    e.preventDefault();
    if (e.nativeEvent) {
        e.nativeEvent.stopImmediatePropagation();
    }
}

export default cancelEvent;
